<template>
    <ul class="usp">
        <template v-if="!isChristmasSeason">
            <li v-for="(usp, index) in uspLists" :key="index" class="usp__item">
                <span class="usp__icon">
                    <img :src="`/nuxt-assets/images/icons/usp/${usp.icon}.svg`" :alt="usp.title" height="12" />
                </span>
                <p class="d-inline-block my-0" v-html="usp.title"></p>
            </li>
        </template>
        <template v-else>
            <li v-for="(usp, index) in christmasUspLists" :key="index" class="usp__item christmas">
                <img
                    :src="`/nuxt-assets/images/icons/usp/${usp.icon}.svg`"
                    class="usp__item--img"
                    :alt="usp.title"
                    width="40"
                    height="40"
                />
                <p v-html="usp.title"></p>
            </li>
        </template>
    </ul>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const props = defineProps({
    showFreeShippingInApp: Boolean,
})

const i18n = useI18n()

const uspLists = [
    {
        icon: i18n.t('usp.benefit1.icon'),
        title: i18n.t('usp.benefit1.title'),
    },
    {
        icon: i18n.t('usp.benefit2.icon'),
        title: i18n.t('usp.benefit2.title'),
    },
    {
        icon: i18n.t('usp.benefit3.icon'),
        title: i18n.t('usp.benefit3.title'),
    },
]

if (props.showFreeShippingInApp) {
    uspLists[0] = {
        icon: i18n.t('usp.benefit1Alternative.icon'),
        title: i18n.t('usp.benefit1Alternative.title'),
    }
}

// IT-835 - xmas header disabled
// const date = new Date()
// const currentDate = date.getFullYear() * 10000 + (date.getMonth() + 1) * 100 + date.getDate()
const isChristmasSeason = false // currentDate < parseInt(useRuntimeConfig().public.xmasDelivery)
const christmasUspLists = [
    {
        icon: i18n.t('uspChristmas.benefit1.icon'),
        title: i18n.t('uspChristmas.benefit1.title'),
    },
    {
        icon: i18n.t('uspChristmas.benefit2.icon'),
        title: i18n.t('uspChristmas.benefit2.title'),
    },
    {
        icon: i18n.t('uspChristmas.benefit4.icon'),
        title: i18n.t('uspChristmas.benefit4.title'),
    },
]
</script>

<style lang="scss" scoped>
.usp {
    list-style: none;
    padding: 0;
    font-size: 12px;
    font-weight: bold;
    color: $color-green-dark;
    margin: 3px 0 0;

    &__icon {
        padding: 5px;
        background: $color-green-light;
        border-radius: 50px;
        margin-right: 8px;
        width: 22px;
        height: 22px;
        display: inline-block;
        line-height: 0;
        text-align: center;
    }

    &__item {
        margin-top: 15px;

        &.christmas {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: $color-dark;

            p {
                margin: 0;
            }
        }

        &--img {
            margin-right: 10px;
        }
    }
}
</style>
